<template>
  <modal title="Inventory Filter" hide-top>
    <div class="mx-2">
      <b-form-group label="Boolean Filters" label-class="font-weight-bold" label-size="md" class>
        <b-form-radio-group v-model="filter.booleanop">
          <b-form-radio value="N">None</b-form-radio>
          <b-form-radio value="AND">AND</b-form-radio>
          <b-form-radio value="OR">OR</b-form-radio>
        </b-form-radio-group>
        <b-form-checkbox-group :disabled="filter.booleanop == 'N'" v-model="filter.boolean">
          <b-form-checkbox value="listed">Listed</b-form-checkbox>
          <b-form-checkbox value="not_listed">Not Listed</b-form-checkbox>
          <b-form-checkbox value="orderable">Orderable</b-form-checkbox>
          <b-form-checkbox value="not_orderable">Not Orderable</b-form-checkbox>
          <b-form-checkbox value="photos">Has Photos</b-form-checkbox>
          <b-form-checkbox value="not_photos">Has No Photos</b-form-checkbox>
          <b-form-checkbox value="scrapped">Scrapped</b-form-checkbox>
          <b-form-checkbox value="adjusted">Adjusted</b-form-checkbox>
          <b-form-checkbox value="sold">Sold</b-form-checkbox>
          <b-form-checkbox value="returned">Returned</b-form-checkbox>
          <b-form-checkbox value="putaway">Putaway</b-form-checkbox>
          <b-form-checkbox value="not_putaway">Not Putaway</b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
      <b-form-group label="Condition Filters" label-class="font-weight-bold" label-size="md">
        <b-form-checkbox-group v-model="filter.grades">
          <b-form-checkbox value="N">New</b-form-checkbox>
          <b-form-checkbox value="O">New - Open Box</b-form-checkbox>
          <b-form-checkbox value="R">Refurbished</b-form-checkbox>
          <b-form-checkbox value="A">Used - Grade A</b-form-checkbox>
          <b-form-checkbox value="B">Used - Grade B</b-form-checkbox>
          <b-form-checkbox value="C">Used - Grade C</b-form-checkbox>
          <b-form-checkbox value="D">Used - Grade D</b-form-checkbox>
          <b-form-checkbox value="F">Used - Grade F</b-form-checkbox>
          <b-form-checkbox value="U">Unspecified</b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
      <b-form-group label="Text Filters" label-class="font-weight-bold">
        <b-button variant="link" size="sm" @click="addText">Add</b-button>
        <b-input-group v-for="(text, index) in filter.texts" :key="index" class="mb-2">
          <template #prepend>
            <b-form-select v-model="filter.texts[index].key" size="sm" :options="filterCols"/>
          </template>
          <b-form-input v-model="filter.texts[index].query" size="sm"/>
        </b-input-group>
      </b-form-group>
    </div>
    <template #footer>
      <b-button variant="outline-secondary" class="px-3 mr-2" @click="$root.$emit('submit', false)" size="sm">Cancel</b-button>
      <b-button variant="outline-primary" class="px-3" size="sm" @click="done">Apply</b-button>
    </template>

  </modal>
</template>

<script>
export default {
  name: "item-inventory-filter",
  props: ['value'],
  data() {
    return {
      filter: null,
      filterCols: [
        {value: 'notes', text: 'Notes'},
        {value: 'location', text: 'Location'},
        {value: 'po', text: 'PO'},
        {value: 'serialno', text: 'Serial'},
        {value: 'auction', text: 'Listing'},
        {value: 'order', text: 'Order'},
        {value: 'createdby_user', text: 'Recvd By'},
        {value: 'user1', text: 'User 1'},
        {value: 'user2', text: 'User 2'},
      ]
    }
  },
  created() {
    this.filter = this.value ? this.value : {
      boolean: [],
      booleanop: 'N',
      texts: [],
      byid: []
    }
  },
  methods: {
    addText() {
      this.filter.texts.push({key: this.filterCols[0].value, query: ''})
    },
    done() {
      this.$emit('submit', this.filter)
    }
  }
}
</script>

<style scoped>

</style>